export const FULL_ONBOARDING_STEPS = 5;

export const STEP_META: Record<number, { label: string; title: string }> = {
  1: { label: "About you", title: "Let's learn more about you" },
  2: { label: "Your company", title: "Create your organization profile" },
  3: { label: "Your first project", title: "Create your first project" },
  4: { label: "Customize your experience", title: "Help us customize your experience" },
  5: { label: "Choose your plan", title: "Choose the plan that fits your team" },
};

export const STEP_2_EMPLOYER_META = {
  label: "Your company",
  title: "Update your employer profile",
};

export const contentVariants = {
  enter: (dir: number) => ({ x: dir > 0 ? 40 : -40, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (dir: number) => ({ x: dir > 0 ? -40 : 40, opacity: 0 }),
};
